import { Component, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-priors',
    templateUrl: './priors.component.html'
})
export class PriorsComponent implements OnChanges {
    // A list of forms with controls: modality, studyId, noOfImages, accessionNumber and studyDescription
    @Input()
    priorForms: FormArray<FormGroup>;

    @Input()
    priorSent: boolean;

    @Input()
    modalityList: string[];

    @Output()
    addPrior = new EventEmitter();

    @Output()
    deletePrior = new EventEmitter<number>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['priorSent']) {
            const enabled = changes['priorSent'].currentValue;
            for (const priorFormGroup of this.priorForms.controls) {
                if (enabled) {
                    priorFormGroup.controls.modality.setValidators(Validators.required);
                    priorFormGroup.controls.modality.enable();
                    priorFormGroup.controls.priorDate.setValidators(Validators.required);
                    priorFormGroup.controls.priorDate.enable();
                } else {
                    priorFormGroup.controls.modality.setValidators(Validators.nullValidator);
                    priorFormGroup.controls.modality.disable();
                    priorFormGroup.controls.priorDate.setValidators(Validators.nullValidator);
                    priorFormGroup.controls.priorDate.disable();
                }
            }
        }
    }

    deletePriorInternal(index: number) {
        this.deletePrior.emit(index);
    }

    addPriorInternal() {
        this.addPrior.emit();
    }

    dateFilter = (date: Date): boolean => date <= new Date();
}
